import tracking from '../../utils/tracking';

export default class PageLeaveTracking {
  params: any;
  maxScrolled: number;

  constructor(_domRoot: HTMLElement, params: any) {
    this.params = params;
    this.maxScrolled = 0;
    this.init();
  }

  roundNum(num: number) {
    return Math.round(num * 100) / 100;
  }

  init() {
    document.addEventListener("scroll", () => {
      if (window.scrollY > this.maxScrolled) {
        this.maxScrolled = window.scrollY;
      }
    });
    window.addEventListener("beforeunload", () => {

      const topOfPage = this.maxScrolled;
      const bottomOfViewport = topOfPage + window.innerHeight;
      const pageHeight = document.body.scrollHeight;
      const maxScrollPercent = ( topOfPage / pageHeight ) * 100;
      const maxPagePercentViewed = (( bottomOfViewport / pageHeight )) * 100

      tracking.trackEvent('Exited Page', {
        event: "scrolled",
        action: "scrolled",
        eventComponent: "page",
        eventContainer: "page",
        actionSubject: "page",
        pageHeight: pageHeight,
        maxScrollPercent: this.roundNum(maxScrollPercent),
        maxPagePercentViewed: this.roundNum(maxPagePercentViewed > 100 ? 100 : maxPagePercentViewed)
      });
    });
  }
}
